import { FC } from 'react';
import { Box, IconButton, Svg, Text } from '@hopskipdrive/react-components';
import { TypographyProps } from '@mui/material';

import { useToast } from '../../contexts/ToastContext';
import { colorTokens } from '../variables';

interface CopyToClipboardProps {
  toastMessage: string;
  text: string;
  variant: Exclude<TypographyProps['variant'], 'inherit'>;
  color?: string;
  truncate?: boolean;
  textStyle?: React.CSSProperties;
  iconColor?: string;
}

export const CopyToClipboard: FC<CopyToClipboardProps> = ({
  toastMessage,
  text,
  variant,
  color,
  truncate = false,
  textStyle,
  iconColor = 'inherit',
}) => {
  const { addToast } = useToast();

  const copyToClipboard = () => {
    if (window.isSecureContext) {
      navigator.clipboard.writeText(text);
      addToast({
        severity: 'info',
        message: toastMessage,
        alertProps: {
          icon: false,
          onClose: undefined,
          style: {
            border: `1px solid ${colorTokens.primary.borderDark}`,
            background: colorTokens.primary.contrast,
            color: colorTokens.text.primary,
          },
        },
      });
    }
  };

  return (
    <Box display="flex" flexDirection="row" alignItems="center" style={{ color: color }}>
      <Text
        variant={variant}
        style={{
          color: color,
          ...(truncate
            ? {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '250px',
              }
            : {
                overflow: 'visible',
                textOverflow: 'unset',
                whiteSpace: 'normal',
                maxWidth: 'unset',
              }),
          ...textStyle,
        }}
      >
        {text}
      </Text>
      <IconButton onClick={copyToClipboard} size="small" style={{ color: iconColor }}>
        <Svg icon="duplicate" width="24px" height="24px" />
      </IconButton>
    </Box>
  );
};
